/**
 * AccordionContent.jsx
 * Created by michaelbray on 3/8/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    showRow: PropTypes.bool,
    content: PropTypes.node
};

export default class AccordionContent extends React.Component {
    render() {
        let contentClass = 'hide-content';
        if (this.props.showRow) {
            contentClass = 'show-content';
        }

        return (
            <div className={`rec-accordion-content ${contentClass}`}>
                { this.props.content }
            </div>
        );
    }
}

AccordionContent.propTypes = propTypes;
